package com.vizio.redwolf.consent.model

import kotlinx.serialization.Serializable


data class UserConsentV2ProxyStatusRequestInfo(
    val userId: String,
    val userIdType: String,
    val consentIds: List<String>,
    val consentGroupIds: List<String>,
    val accessToken: String
)

data class SaveUserConsentV2ProxyRequestInfo(
    val userId: String,
    val userIdType: String,
    val consentIdsActions: ConsentAction,
    val consentGroupIdsActions: ConsentGroupAction,
    val consentToken: String,
    val accessToken: String
)
